import { Voni } from '../client';

export interface ProjectMember {
  id: number;
  project_id: number;
  user_id: number;
  role: 'owner' | 'admin' | 'member' | 'viewer';
  added_at: string;
  added_by?: number;
  user_email?: string;
  user_full_name?: string;
}

export interface ProjectMemberCreateInput {
  email: string;
  role: 'admin' | 'member' | 'viewer';
}

export interface ProjectMemberUpdateInput {
  role: 'admin' | 'member' | 'viewer';
}

export class ProjectMembersResource {
  constructor(private client: Voni) {}

  async list(projectId: string | number, skip?: number, limit?: number): Promise<ProjectMember[]> {
    const params: Record<string, unknown> = {};
    if (skip) params.skip = skip;
    if (limit) params.limit = limit;
    return this.client.request<ProjectMember[]>('GET', `/projects/${projectId}/members`, params);
  }

  async add(projectId: string | number, data: ProjectMemberCreateInput): Promise<ProjectMember> {
    return this.client.request<ProjectMember>('POST', `/projects/${projectId}/members`, undefined, data);
  }

  async update(projectId: string | number, memberId: number, data: ProjectMemberUpdateInput): Promise<ProjectMember> {
    return this.client.request<ProjectMember>('PUT', `/projects/${projectId}/members/${memberId}`, undefined, data);
  }

  async remove(projectId: string | number, memberId: number): Promise<void> {
    await this.client.request('DELETE', `/projects/${projectId}/members/${memberId}`);
  }
}
